<app-si-dialog #dialogComponent header="Warning" modalFooterClasses="si-dialog__footer--centered" (save)="dialogComponent.onClose(true)">
  <ng-template appDialogBody>
    <div class="px-16 py-8">
      <div class="flex items-center gap-5">
        <fa-icon class="text-primary-light shrink-0 mt-0.5" [icon]="['fal', 'circle-exclamation']" size="2x"></fa-icon>
        <p class="mb-0">Your data will be cleared and re-synced to match your new settings. It may take several hours to complete this process.</p>
      </div>
    </div>
  </ng-template>
</app-si-dialog>
